<template>
  <div class="w-full  px-6 ">
    <div class="relative items-center h-20 md:border-b hidden md:block">
    <div class="h-full md:absolute px-6 md:px-0 right-8 md:right-0 w-full md:w-9/12 lg:w-7/12 md:flex md:flex-row justify-between items-center">
      <h4 class="text-yank mt-4 mb-4 md:mt-auto md:mb-auto">Social Channels</h4>
      <button v-on:click="addAccount" class="flex items-center cursor-pointer mb-4 md:mb-0">
        <h2 class=" text-carolina mr-3 text-sm lg:text-base">Add Channel</h2>
        <PlusIcon/>
      </button> 
    </div> 
    </div>
    <div class="h-full overflow-scroll relative mt-10 pb-10">
      <ConnectionRow :account="accounts" @update="$emit('updateConnection')" @remove="$emit('removeConnection')" @link="$emit('updateConnection')"/>

      <button v-on:click="addAccount" class="flex items-center justify-center cursor-pointer mb-4 md:hidden mx-auto">
        <h2 class="text-carolina mr-3 text-sm lg:text-base">Add Channel</h2>
        <PlusIcon/>
      </button> 
      
      <ConnectedRow :pages="userAccounts">
        <template slot="rowContent">
          <AccountTypeRow v-for="account in userAccounts" :key="account.access_token" @changeMedia="addAccount" :account="account"/>
        </template>  
      </ConnectedRow>  

      <ConnectedRow title="Facebook Pages" :pages="userPages">
        <template slot="rowContent">
          <AccountTypeRow v-for="account in userPages" :key="account.access_token" @changeMedia="addAccount" :account="account"/>
        </template>  
      </ConnectedRow> 
  
      <ConnectedRow isGroup='true' title="Facebook Groups" :canAddGroup="accounts.length > 0" text="Link a Facebook account to access Groups" information="You can toggle Facebook Groups on and off here as well as in the Scheduler Modal." :pages="userGroups" @addGroups="$emit('updateGroupsConnection')"> 
        <template v-if="userGroups.length > 0" slot="rowContent">
          <AccountTypeRow v-for="account in userGroups" :key="account.access_token" @changeMedia="addAccount" :account="account"/>
          <div class="flex justify-center">
            <button @click="$emit('updateGroupsConnection')" class="flex bg-aquamarine text-white rounded-lg px-13 py-4">
              <span class="text-sm">Update Groups</span>
            </button>
          </div>
        </template>  
      </ConnectedRow> 
    </div>         
  </div>
  
</template>

<script>
import AccountTypeRow from '@/components/settings/social/partials/AccountTypeRow';
import ConnectionRow from '@/components/settings/social/partials/ConnectionRow';
import ConnectedRow from '@/components/settings/social/partials/ConnectedRow';
import PlusIcon from '@/components/svg/Plus';
export default {
    name:"MediaSetting",
    components: {
        PlusIcon,
        AccountTypeRow,
        ConnectionRow,
        ConnectedRow,
    },

     props: {
      accounts: {
        type:Array,
        require:true
      },
      invalidAccounts: {
        type:Array,
        require:true
      },
      userPages:{
        type:Array,
        require:true
      },
      userAccounts:{
        type:Array,
        require:true
      },
      userGroups:{
        type:Array,
        require:true
      }
    },

    methods: {
        addAccount() {
          this.$emit('toggleMediaSubmit');
        },
        openConfirmGroup(){
          this.$emit('openGroup');
        }
      },
}
</script>